import IconFacebook from 'src/assets/img/ic_facebook.svg';
import IconPinterest from 'src/assets/img/ic_pinterest.svg';
import IconTwitter from 'src/assets/img/ic_twitter.svg';
import { ICustomGiftlist, IProduct } from 'typings/generated/contentful';

import {
  getFacebookLink,
  getPinterestLink,
  getTwitterLink,
} from './social-links';

export const getShareLinks = (
  product: IProduct | ICustomGiftlist,
  absoluteSlug: string
) => [
  {
    icon: IconFacebook,
    ariaLabel: 'Facebook',
    link: getFacebookLink({
      pageLink: absoluteSlug,
      title: product.fields.title,
    }),
  },
  {
    icon: IconTwitter,
    ariaLabel: 'Twitter',
    link: getTwitterLink({
      pageLink: absoluteSlug,
      title: product.fields.title,
    }),
  },
  {
    icon: IconPinterest,
    ariaLabel: 'Pinterest',
    link: getPinterestLink({
      pageLink: absoluteSlug,
      title: product.fields.title,
    }),
  },
];
